var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFfGridView({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 0.998047,
    width: 5,
    height: 5,
    rx: 1,
    fill: "#A5ACBB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.998047,
    width: 5,
    height: 5,
    rx: 1,
    fill: "#A5ACBB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 0.998047,
    width: 5,
    height: 5,
    rx: 1,
    fill: "#A5ACBB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 9.99805,
    width: 5,
    height: 5,
    rx: 1,
    fill: "#A5ACBB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 9.99805,
    width: 5,
    height: 5,
    rx: 1,
    fill: "#A5ACBB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 9.99805,
    width: 5,
    height: 5,
    rx: 1,
    fill: "#A5ACBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFfGridView);
export default __webpack_public_path__ + "static/media/ff-grid-view.a4faebfc7d34fa5ddf092ea96c8a6f2e.svg";
export { ForwardRef as ReactComponent };